import React, {useState} from 'react';
import {NavLink} from "react-router-dom";

import {postRequest} from "../routes/Routes";
import {createUser} from "../auth/Auth";

import '../assets/css/Login.css';

import logo from "../assets/images/logo.svg";

function Login() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const loginFunction = (event) => {
        setLoading(true);
        event.preventDefault();
        let values = {
            dto: {
                email: event.target.email.value,
                password: event.target.password.value,
                authProvider: 'RCACCOUNTING',
            },
            context: {
                action: 'Login'
            },
            endpoint: '/api/auth/token'
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                response.data.user = {...response.data.user, token: response.data.token};
                createUser(response.data.user).then(() => {
                    setError(values => ({...values, error: false, errorMessage: null}));
                    window.location.href = '/';
                });
            } else {
                setError(values => ({
                    ...values,
                    error: true,
                    errorMessage: response.data.message ? response.data.message : "An error occurred!"
                }));
            }
            setLoading(false);
        });
    }

    return (
        <div className="main">
            <div className='sub-main'>
                <form onSubmit={loginFunction}>
                    <div className='img'>
                        <img src={logo} alt="Logo"/>
                    </div>
                    <div>
                        <p className='heading'>Welcome to Rahman & Co</p>
                        <p className='description'>Let's build something great</p>
                    </div>
                    <div className="login-input-container">
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input type="email" className="form-control login-input" name="email"
                                   placeholder="Type your email" required/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input type="password" className="form-control login-input" name="password"
                                   placeholder="Type your password" required/>
                            <NavLink className="nav-link forgot-password" to="/forgot-password">Forgot
                                password?</NavLink>
                        </div>
                    </div>
                    {error.error &&
                    <div className="alert login-alert alert-danger" role="alert">
                        {error.errorMessage}
                    </div>}
                    <div>
                        <button type="submit" className='black-button login-button' disabled={loading}>
                            {loading ?
                                <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                      aria-hidden="true"/>
                                : null
                            }
                            Log In
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Login;
